// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../node_modules/css-loader/dist/cjs.js!../../node_modules/bootstrap-icons/font/bootstrap-icons.min.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
	cursor: default;
	background-color: #ffffff;
	padding-bottom: 4em;
	padding-top: 70px;
}

.card-document .card-body, .card-document .card-body textarea {
	font-size: 0.9em;
	line-height: 1;
}

.card-document .card-footer {
	line-height: 1.3;
}

.cursor-drag-ns {
	cursor: ns-resize;
}

.cursor-pointer {
	cursor: pointer;
}

.disabled {
	cursor: default;
	opacity: .6;
	pointer-events: none;
}

.fa.fa-chevron-left::after {
	content: "<";
}

.fa.fa-chevron-right::after {
	content: ">";
}

.img-small-thumb {
	width: 60px;
}

#map {
	height: 500px;
	width: 100%;
}

`, "",{"version":3,"sources":["webpack://./src/css/custom.css"],"names":[],"mappings":"AAEA;CACC,eAAe;CACf,yBAAyB;CACzB,mBAAmB;CACnB,iBAAiB;AAClB;;AAEA;CACC,gBAAgB;CAChB,cAAc;AACf;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,iBAAiB;AAClB;;AAEA;CACC,eAAe;AAChB;;AAEA;CACC,eAAe;CACf,WAAW;CACX,oBAAoB;AACrB;;AAEA;CACC,YAAY;AACb;;AAEA;CACC,YAAY;AACb;;AAEA;CACC,WAAW;AACZ;;AAEA;CACC,aAAa;CACb,WAAW;AACZ","sourcesContent":["@import url(\"/node_modules/bootstrap-icons/font/bootstrap-icons.min.css\");\r\n\r\nbody {\r\n\tcursor: default;\r\n\tbackground-color: #ffffff;\r\n\tpadding-bottom: 4em;\r\n\tpadding-top: 70px;\r\n}\r\n\r\n.card-document .card-body, .card-document .card-body textarea {\r\n\tfont-size: 0.9em;\r\n\tline-height: 1;\r\n}\r\n\r\n.card-document .card-footer {\r\n\tline-height: 1.3;\r\n}\r\n\r\n.cursor-drag-ns {\r\n\tcursor: ns-resize;\r\n}\r\n\r\n.cursor-pointer {\r\n\tcursor: pointer;\r\n}\r\n\r\n.disabled {\r\n\tcursor: default;\r\n\topacity: .6;\r\n\tpointer-events: none;\r\n}\r\n\r\n.fa.fa-chevron-left::after {\r\n\tcontent: \"<\";\r\n}\r\n\r\n.fa.fa-chevron-right::after {\r\n\tcontent: \">\";\r\n}\r\n\r\n.img-small-thumb {\r\n\twidth: 60px;\r\n}\r\n\r\n#map {\r\n\theight: 500px;\r\n\twidth: 100%;\r\n}\r\n\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
